import dayjs from "dayjs";
import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { shortMonthAndYear, customRangeFormat } from "@similarweb/pro-logic-components";
import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { Banner, Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import DurationService from "app/services/DurationService";
import { useDisplayAdvertiserPublisherDataAndParams } from "app/pages/digital-marketing/ad-intelligence/common/hooks/useDisplayAdvertiserPublisherDataAndParams";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const BannerStyled = styled(Banner)`
    margin-bottom: 24px;
`;

const BannerTitle = styled(I18n)`
    ${setFontVariant("body1", colorsPalettes.carbon[500])};
`;

interface IMixedScrapperBannerProps {
    newScrapingDateString?: string;
}

const formatDateRange = (from: dayjs.Dayjs, to: dayjs.Dayjs) => {
    const fromFormatted = from.format(shortMonthAndYear);
    const toFormatted = to.format(shortMonthAndYear);

    return fromFormatted === toFormatted ? fromFormatted : `${fromFormatted} - ${toFormatted}`;
};

export const MixedScrapperBanner = ({ newScrapingDateString }: IMixedScrapperBannerProps) => {
    const params = useDisplayAdvertiserPublisherDataAndParams();
    const { from, to } = DurationService.getDurationData(params.duration).raw;

    const newScrapingDate = dayjs(newScrapingDateString);
    const oldScrapingDate = newScrapingDate.subtract(1, "month");

    const newScrapingDateFormatted = formatDateRange(newScrapingDate, to);
    const oldScrapingDateFormatted = formatDateRange(from, oldScrapingDate);

    const handleCTAClick = () => {
        void proNavigator.applyUpdateParams({
            ...params,
            duration: `${from.format(customRangeFormat)}-${oldScrapingDate.format(customRangeFormat)}`,
            ignoreFilterConsistency: true,
        });
    };

    return newScrapingDateString?.length > 0 ? (
        <BannerStyled
            CustomIcon={
                <SWReactIcons
                    size="sm"
                    iconName="alerts"
                />
            }
            title={
                <BannerTitle
                    dangerouslySetInnerHTML
                    dataObj={{ dateFormatted: newScrapingDateFormatted }}
                >
                    ad.intelligence.advertiser.ad.widget.banner.title
                </BannerTitle>
            }
            CustomButton={
                <Button
                    type="flat"
                    onClick={handleCTAClick}
                >
                    {translate("ad.intelligence.advertiser.ad.widget.banner.button", {
                        dateFormatted: oldScrapingDateFormatted,
                    })}
                </Button>
            }
        />
    ) : null;
};
